import React from "react";
import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";

export default function Hero() {
  const { t } = useI18n();
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-20 min-h-[92vh] flex items-end overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_gallura-auto-rental/artifacts/dangqjp8_1782509039541.jpg.jpg"
          alt="Chrysler 300C Touring blu con autista in Gallura"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-[#F9F7F3]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pb-24 pt-32 w-full">
        <div className="max-w-3xl">
          <p
            className="text-xs md:text-sm uppercase tracking-[0.3em] text-white/90 fade-up"
            data-testid="hero-eyebrow"
          >
            {t.hero.eyebrow}
          </p>
          <h1
            className="font-display text-5xl md:text-6xl lg:text-7xl text-white mt-6 leading-[1.05] fade-up fade-up-delay-1"
            data-testid="hero-title"
          >
            {t.hero.title}
          </h1>
          <p className="text-lg md:text-xl text-white/90 mt-6 max-w-2xl fade-up fade-up-delay-2">
            {t.hero.subtitle}
          </p>
          <div className="mt-10 flex flex-wrap gap-4 fade-up fade-up-delay-3">
            <Button
              data-testid="hero-cta-book"
              onClick={() =>
                document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" })
              }
              className="brand-bg hover:opacity-90 text-white rounded-full px-7 py-6 text-base"
            >
              {t.hero.cta_primary}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <Button
              data-testid="hero-cta-services"
              variant="outline"
              onClick={() =>
                document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })
              }
              className="rounded-full px-7 py-6 text-base bg-white/10 hover:bg-white/20 border-white/40 text-white"
            >
              {t.hero.cta_secondary}
            </Button>
          </div>
        </div>

        {/* KPIs */}
        <div className="mt-16 grid grid-cols-3 gap-6 max-w-2xl fade-up fade-up-delay-4">
          {[
            { v: "10+", l: t.hero.kpi_1 },
            { v: "50+", l: t.hero.kpi_2 },
            { v: "5★", l: t.hero.kpi_3 },
          ].map((k) => (
            <div key={k.v} className="text-white">
              <div className="font-display text-3xl md:text-4xl accent-text">{k.v}</div>
              <div className="text-xs md:text-sm uppercase tracking-widest text-white/80 mt-1">
                {k.l}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
